import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import moment from 'moment';
import get from 'lodash/get';
import map from 'lodash/map';
import join from 'lodash/join';

import Notes from 'modules/Notes/index';
import FilterBloc from 'modules/Notes/components/CompareFilter/FilterBloc';
import CompareTab from 'modules/Notes/components/CompareTab';
import CompareBarGraph from 'modules/Notes/components/CompareBarGraph';
import CompareHistoryLineChart from 'modules/Notes/components/CompareHistoryLineChart';
import WxrKpi from 'modules/Notes/components/WxrKpi';

import {
  getNotationCompare,
  getNotationHeaderCompare,
  getNotationCompareAdditionalRivals
} from 'actions/notes';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  max-width: calc(100%);

  .cardHeaderRight {
    max-height: 30px;
  }

  .rightComponentsContainer {
    display: flex;
  }

  .rightComponentsContainer > :not(:last-child) {
    margin: 0 10px 0 0;
  }

  .twoColumns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-top: 20px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .twoColumns {
      grid-template-columns: 1fr;
    }
  }

  .recharts-responsive-container {
    position: relative;
  }

  .compareTabContainer {
    margin-top: 20px;
  }
`;

class NotesComparison extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wine: null,
      vintage: null,
      appellation: [],
      rank: [],
      loading: true,
      loadingTab: true,
      display: [
        {
          label: 'Primeur',
          checked: true
        },
        {
          label: 'Livrable',
          checked: false
        }
      ]
    };
  }

  async componentDidMount() {
    await this.props.getNotationHeaderCompare();
    await this.props.getNotationCompare().then(() => {
      this.setState({ loading: false });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      this.props.headerCompare &&
      this.props.data.all_notes &&
      (this.props.headerCompare !== prevProps.headerCompare ||
        this.props.data !== prevProps.data) &&
      this.props.headerCompare.client_wines &&
      this.props.headerCompare.client_wines.length > 0
    ) {
      let maxVintage = this.props.data.all_notes.filter(
        (item) =>
          item.wine_name === this.props.headerCompare.client_wines[0].wine_name
      );
      if (Array.isArray(maxVintage)) {
        maxVintage.sort(function (a, b) {
          return String(a.vintage).localeCompare(String(b.vintage));
        });
        maxVintage = [...maxVintage];
        maxVintage = maxVintage.pop();
      }
      this.setState({
        wine: {
          label: this.props.headerCompare.client_wines[0].wine_name,
          value: this.props.headerCompare.client_wines[0].wine_name
        },
        vintage: {
          label: maxVintage ? maxVintage.vintage : null,
          value: maxVintage ? maxVintage.vintage : null
        },
        // Valeur par défaut incorrecte si on n'a pas de WXR
        tasterPrimeur: {
          label: 'WXR',
          value: 'wxr_primeur'
        },
        tasterNote: {
          label: 'WXR',
          value: 'wxr_note'
        }
      });

      // If we have a single type, we need to set it, since the radio will be diabled
      if (this.numberOfTypes() < 2) {
        const data = this.props.data.all_notes || [];
        this.setState({
          display: [
            {
              label: 'Primeur',
              checked: data.length > 0 && data[0].french_note_type === 'Primeur'
            },
            {
              label: 'Livrable',
              checked:
                data.length > 0 && data[0].french_note_type === 'Livrable'
            }
          ]
        });
      }
    }
  }

  formatData(data) {
    const all_notes = data.all_notes || [];
    let wxr_notes = data.wxr_notes || [];
    let aggregatedNotes = [];
    for (let note of all_notes) {
      let currentComboIndex = aggregatedNotes.findIndex(
        (item) =>
          item.wine_name === note.wine_name && item.vintage === note.vintage
      );
      if (currentComboIndex >= 0 && aggregatedNotes[currentComboIndex]) {
        let currentData = aggregatedNotes[currentComboIndex];
        if (note.french_note_type === 'Primeur') {
          currentData[note.journalist_short_name + '_primeur'] =
            note.normalized_note_filtered;
          currentData[note.journalist_short_name + '_rawPrimeur'] =
            note.note_filtered;
          currentData[note.journalist_short_name + '_rawPrimeurFloat'] =
            note.float_note_filtered;
        } else {
          if (
            !currentData[note.journalist_short_name + '_note'] ||
            currentData[note.journalist_short_name + '_note'] === '-'
          ) {
            currentData[note.journalist_short_name + '_note'] =
              note.normalized_note_filtered;
            currentData[note.journalist_short_name + '_rawNote'] =
              note.note_filtered;
            currentData[note.journalist_short_name] = note;
          }
        }
        if (!currentData[note.journalist_short_name + '_note']) {
          currentData[note.journalist_short_name + '_note'] = '-';
        }
        if (!currentData[note.journalist_short_name + '_rawNote']) {
          currentData[note.journalist_short_name + '_rawNote'] = '-';
        }
        if (!currentData[note.journalist_short_name + '_allnotes']) {
          currentData[note.journalist_short_name + '_allnotes'] = [note];
        } else {
          currentData[note.journalist_short_name + '_allnotes'].push(note);
        }
      } else {
        aggregatedNotes.push({
          wine_name: note.wine_name,
          vintage: note.vintage,
          [note.journalist_short_name + '_allnotes']: [note],
          [note.journalist_short_name + '_note']:
            note.french_note_type !== 'Primeur'
              ? note.normalized_note_filtered
              : '-',
          [note.journalist_short_name + '_rawNote']:
            note.french_note_type !== 'Primeur' ? note.note_filtered : '-',
          [note.journalist_short_name]: note,
          [note.journalist_short_name + '_primeur']:
            note.french_note_type === 'Primeur'
              ? note.normalized_note_filtered
              : null,
          [note.journalist_short_name + '_rawPrimeur']:
            note.french_note_type === 'Primeur' ? note.note_filtered : '-',
          [note.journalist_short_name + '_rawPrimeurFloat']:
            note.french_note_type === 'Primeur' ? note.float_note_filtered : '-'
        });
      }
    }
    wxr_notes.forEach((note) => {
      let currentComboIndex = aggregatedNotes.findIndex(
        (item) =>
          item.wine_name === note.wine_name && item.vintage === note.vintage
      );
      if (currentComboIndex >= 0) {
        aggregatedNotes[currentComboIndex] = {
          ...aggregatedNotes[currentComboIndex],
          wxr_note: note.wxr ? note.wxr.toFixed(2) : 0,
          wxr_primeur: note.wxr_primeur ? note.wxr_primeur.toFixed(2) : 0,
          appellation_name: note.appelation_name,
          classement_name: note.classement_name
        };
      } else {
        aggregatedNotes.push({
          wine_name: note.wine_name,
          vintage: note.vintage,
          wxr_note: note.wxr ? note.wxr.toFixed(2) : 0,
          appellation_name: note.appelation_name,
          classement_name: note.classement_name,
          wxr_primeur: note.wxr_primeur ? note.wxr_primeur.toFixed(2) : 0
        });
      }
    });
    return aggregatedNotes;
  }

  getOptions(data) {
    let appelations = this.props.headerCompare.appelations || [];
    let classements = this.props.headerCompare.classements || [];

    const wineOption = [...new Set(data.map((item) => item.wine_name))].map(
      (item) => ({
        value: item,
        label: item
      })
    );

    const rankOptions = classements.map((item) => ({
      value: item.id,
      label: item.name
    }));

    const appellationOptions = appelations.map((item) => ({
      value: item.id,
      label: item.name
    }));

    const vintageOptions = [...new Set(data.map((item) => item.vintage))]
      .sort()
      .map((item) => ({ value: item, label: item }));

    return {
      rank: rankOptions,
      appellation: appellationOptions,
      vintage: vintageOptions,
      wine: wineOption
    };
  }

  handleRadioChange(label) {
    let { display } = this.state;
    display.forEach((button) => {
      button.checked = button.label === label;
    });
    this.setState({ display });
  }

  filterData(formattedData) {
    let filteredData = [...formattedData];
    const { vintage, wine } = this.state;
    filteredData = wine
      ? filteredData.filter((item) => item.wine_name === wine.value)
      : filteredData.filter(
          (item) => item.wine_name === filteredData[0].wine_name
        );
    filteredData = vintage
      ? filteredData.filter((item) => item.vintage === vintage.value)
      : wine
        ? []
        : filteredData.filter(
            (item) => item.vintage === filteredData[0].vintage
          );
    return filteredData;
  }

  filterRivals(formattedData, rivals) {
    const { vintage, wine } = this.state;
    if (!formattedData.length) {
      return [];
    }
    let filteredData = [];
    if (wine && rivals[wine.value]) {
      filteredData = [...rivals[wine.value]];
    } else if (rivals[formattedData[0].wine_name]) {
      filteredData = [...rivals[formattedData[0].wine_name]];
    } else {
      return [];
    }
    filteredData = vintage
      ? filteredData.filter((item) => item.vintage === vintage.value)
      : wine
        ? []
        : filteredData.filter(
            (item) => item.vintage === formattedData[0].vintage
          );

    return filteredData;
  }

  filterByWine(data) {
    const { wine } = this.state;
    return wine
      ? data.filter((item) => item.wine_name === wine.value)
      : data.filter((item) => item.wine_name === data[0].wine_name);
  }

  getPrimeurKpi(primeurGraphData) {
    const { tasterPrimeur } = this.state;
    let lastVintage = { value: 0, vintage: '' };
    let bestNote = 0;
    let average = 0;
    let bestVintage = '';
    let bestNoteWxr = false;
    let firstVintage = 0;

    if (primeurGraphData && primeurGraphData.length > 0) {
      firstVintage = Math.min(...primeurGraphData.map((note) => note.vintage));

      if (tasterPrimeur && tasterPrimeur.label !== 'WXR') {
        let data = [...primeurGraphData];
        data = data.filter(
          (item) =>
            item[tasterPrimeur.value + '_rawPrimeur'] &&
            item[tasterPrimeur.value + '_rawPrimeur'] !== '-'
        );
        let maxVintage = data.pop();
        lastVintage = {
          value: maxVintage[tasterPrimeur.value + '_rawPrimeur'],
          vintage: maxVintage.vintage
        };
      } else {
        let maxVintageWithData = [...primeurGraphData]
          .reverse()
          .find((item) => item.wxr_primeur);

        lastVintage.wxr = true;
        lastVintage = maxVintageWithData
          ? {
              value: maxVintageWithData.wxr_primeur,
              vintage: maxVintageWithData.vintage
            }
          : { value: null, vintage: null };
      }

      if (tasterPrimeur && tasterPrimeur.label !== 'WXR') {
        let bestNoteFloat = [...primeurGraphData];
        bestNoteFloat = bestNoteFloat
          .map((note) =>
            note[tasterPrimeur.value + '_rawPrimeurFloat']
              ? note[tasterPrimeur.value + '_rawPrimeurFloat']
              : 0
          )
          .sort();
        bestNoteFloat = bestNoteFloat.pop();

        bestNote = primeurGraphData.find((item) =>
          item[tasterPrimeur.value + '_rawPrimeurFloat']
            ? item[tasterPrimeur.value + '_rawPrimeurFloat'] === bestNoteFloat
            : 0
        );
        bestVintage = bestNote.vintage;
        bestNote = bestNote[tasterPrimeur.value + '_rawPrimeur'];
      }

      if (!tasterPrimeur || !bestNote) {
        bestNote = primeurGraphData
          .filter((item) => item.wxr_primeur)
          .map((note) => note.wxr_primeur)
          .sort();
        bestNoteWxr = true;
        bestNote = bestNote.pop();

        if (!bestNote) {
          bestNote = Math.max(
            ...primeurGraphData.map((note) => note.wxr_primeur)
          );
        }
        bestVintage = primeurGraphData.find(
          (item) => item.wxr_primeur === bestNote
        );
        if (bestVintage) {
          bestVintage = bestVintage.vintage;
        }
      }

      if (!bestNote) {
        bestNote = 0;
      }

      if (tasterPrimeur && tasterPrimeur.label !== 'WXR') {
        average = [...primeurGraphData];
        average = average
          .map((note) => {
            if (note[tasterPrimeur.value + '_allnotes']) {
              const lastNote = note[tasterPrimeur.value + '_allnotes'].pop();
              return lastNote ? lastNote.float_note_filtered : 0;
            }
          })
          .filter((item) => item > 0);

        const countLowFloat = average.filter((item) => item < 25).length;
        const countHighFloat = average.length - countLowFloat;
        if (countHighFloat && countLowFloat) {
          average = [...primeurGraphData]
            .map((note) => note[tasterPrimeur.value + '_primeur'])
            .filter((item) => item > 0);
        }
        let lengthAverage = average.length;
        if (average && average.length > 0) {
          average = average.reduce(
            (value, acc) => Number.parseFloat(value) + Number.parseFloat(acc)
          );
          average = average / lengthAverage;
        }

        average = Number(average).toFixed(2);
      } else {
        const averageData = [...primeurGraphData]
          .filter((item) => item.wxr_primeur)
          .map((note) => note.wxr_primeur);
        average =
          averageData.reduce(
            (value, acc) => Number.parseFloat(value) + Number.parseFloat(acc),
            0
          ) / averageData.length;
        average = Number(average).toFixed(2);
      }

      if (isNaN(average)) {
        average = 0;
      }

      if (!lastVintage) {
        lastVintage = { value: 0, vintage: 0 };
      }
    }

    return [
      {
        title: `${bestNote} ${bestNoteWxr ? '(WXR)' : ''}`,
        type: 'WXR',
        content: (
          <p>
            {I18n.t('notes.compare.indicators.bestNote')} -{' '}
            {bestVintage && <span> {bestVintage}</span>}
          </p>
        ),
        styles: `grid-row-start:1;grid-row-end:3;font-size:16px; h1{font-size:30px !important}`
      },
      {
        title: average,
        type: 'other',
        content: (
          <p>
            {I18n.t('notes.compare.indicators.average')}{' '}
            <span>
              {firstVintage !== 0 &&
                `${firstVintage && firstVintage} - ${
                  lastVintage.vintage && lastVintage.vintage
                }`}
            </span>
          </p>
        )
      },
      {
        title: `${lastVintage.value} ${
          lastVintage.wxr && lastVintage.value ? '(wxr)' : ''
        }`,
        type: 'other',
        content: (
          <p>
            {I18n.t('notes.compare.indicators.lastVintage')} -{' '}
            <span>
              {' '}
              {I18n.t('notes.compare.indicators.vintage')} {lastVintage.vintage}{' '}
            </span>
          </p>
        )
      }
    ];
  }

  getLastNoteKpi(data) {
    const { tasterNote } = this.state;
    let bestNote = 0;
    let bestVintage = '';
    let primeur = 0;
    let last = 0;
    let nb = 0;
    if (data && data.length > 0 && tasterNote && tasterNote.label !== 'WXR') {
      let allnotes = data[0][tasterNote.value + '_allnotes'];
      if (allnotes) {
        nb = allnotes.length;
      } else {
        allnotes = [];
        nb = 0;
      }
      bestNote = Math.max(...allnotes.map((note) => note.float_note_filtered));
      if (bestNote) {
        bestVintage = allnotes.find(
          (item) => item.float_note_filtered === bestNote
        );
        if (bestVintage) {
          bestVintage =
            bestVintage.french_note_type === 'Primeur'
              ? 'Primeur'
              : moment(bestVintage.date).format('YYYY');
        }

        bestNote = allnotes.find(
          (item) => item.float_note_filtered === bestNote
        ).note_filtered;
      }
      if (allnotes[0]) {
        last = allnotes[0].note_filtered;
      } else {
        last = 0;
      }
      primeur = allnotes.find((note) => note.french_note_type === 'Primeur');
      primeur = primeur ? primeur.note_filtered : 0;
    }
    if (data && data.length > 0 && tasterNote && tasterNote.label === 'WXR') {
      nb = 1;
      primeur = data[0].wxr_primeur;
      last = data[0].wxr_note;
      bestNote =
        data[0].wxr_note > data[0].wxr_primeur
          ? data[0].wxr_note
          : data[0].wxr_primeur;
    }
    return [
      {
        title: bestNote,
        content: bestVintage && (
          <p>
            {I18n.t('notes.compare.indicators.bestYear')} -{' '}
            <span> {bestVintage}</span>
          </p>
        )
      },
      {
        title: primeur,
        content: <p>{I18n.t('notes.compare.indicators.primeur')}</p>
      },
      {
        title: last,
        content: <p>{I18n.t('notes.compare.indicators.lastYear')}</p>
      },
      {
        title: nb,
        content: <p>{I18n.t('notes.compare.indicators.total')}</p>
      }
    ];
  }

  formatRivals(data) {
    const client_wines = this.props.headerCompare.client_wines || [];
    const rivalsFormatted = {};
    data.forEach((wineFormatted) => {
      const isClientWine = client_wines.find(
        (item) => item.wine_name === wineFormatted.wine_name
      );
      if (!isClientWine) {
        let wineClient = null;
        client_wines.forEach((wine) => {
          const rival = wine.rivals.find(
            (item) => item === wineFormatted.wine_name
          );
          if (rival) {
            wineClient = wine.wine_name;
            if (!rivalsFormatted[wineClient]) {
              rivalsFormatted[wineClient] = [wineFormatted];
            } else {
              rivalsFormatted[wineClient].push(wineFormatted);
            }
          }
        });
      }
    });

    return rivalsFormatted;
  }

  getExportName() {
    return `${
      get(this.state, 'type.label') ? get(this.state, 'type.label') + '-' : ''
    }${
      get(this.state, 'appellation[0].label')
        ? join(map(get(this.state, 'appellation'), 'label'), '-') + '-'
        : ''
    }${
      get(this.state, 'rank[0].label')
        ? join(map(get(this.state, 'rank'), 'label'), '-') + '-'
        : ''
    }${
      get(this.state, 'vintage.label')
        ? get(this.state, 'vintage.label') + '-'
        : ''
    }${
      get(this.state, 'wine.label') ? get(this.state, 'wine.label') + '-' : ''
    }`;
  }

  removeRivals(formattedData) {
    const client_wines = this.props.headerCompare.client_wines || [];
    return formattedData.filter((wineFormatted) => {
      const isClientWine = client_wines.find(
        (item) => item.wine_name === wineFormatted.wine_name
      );
      return isClientWine;
    });
  }

  numberOfTypes() {
    const data = this.props.data.all_notes || [];
    const options = [...new Set(data.map((item) => item.french_note_type))];
    return options.length;
  }

  async handleChangeCall(field, value) {
    this.setState({ [field]: value, loading: true });
    const { appellation, rank } = this.state;
    if (field === 'rank') {
      await this.props.getNotationCompareAdditionalRivals({
        rank: value.map((item) => item.value),
        appellation: appellation.map((item) => item.value)
      });
    } else {
      await this.props.getNotationCompareAdditionalRivals({
        appellation: value.map((item) => item.value),
        rank: rank.map((item) => item.value)
      });
    }
    this.setState({ loading: false });
  }

  filterAdditionalRivals(data) {
    const { vintage, wine } = this.state;
    data = vintage ? data.filter((item) => item.vintage === vintage.value) : [];
    data = wine ? data.filter((item) => item.wine_name !== wine.label) : [];
    return data;
  }

  filterWxrHistoryRivals(data) {
    const filteredData = [...data];
    const { vintage, wine } = this.state;

    return filteredData.filter(
      (item) =>
        vintage &&
        wine &&
        item.vintage === vintage.value &&
        item.wine_name !== wine.value
    );
  }

  render() {
    let formattedData = this.formatData(this.props.data);
    const rivals = this.formatRivals(formattedData);
    let filteredData = this.filterData(formattedData);
    const filteredRivals = this.filterRivals(formattedData, rivals);
    formattedData = this.removeRivals(formattedData);
    filteredData = this.removeRivals(filteredData);
    const primeurGraphData = this.filterByWine(formattedData);
    let options = this.getOptions(formattedData || []);
    const kpiPrimeurChart = this.getPrimeurKpi(primeurGraphData);
    const kpiLastNote = this.getLastNoteKpi(filteredData);
    const { display, wine, vintage, rank, appellation } = this.state;

    let filteredWxrHistory = this.filterData(this.props.data.wxr_history || []);
    const filteredWxrHistoryRivals = this.filterWxrHistoryRivals(
      this.props.data.wxr_history || []
    );

    const additionalRivals = this.props.additionalRivals;
    let additionalRivalsFormatted = { ...additionalRivals };
    if (
      additionalRivalsFormatted.all_notes &&
      additionalRivalsFormatted.all_notes.length > 0
    ) {
      additionalRivalsFormatted = this.formatData(additionalRivals);
    } else {
      additionalRivalsFormatted = [];
    }
    const filteredAdditionalRivals = this.filterAdditionalRivals(
      additionalRivalsFormatted
    );

    let dataCompareTab = filteredData;
    // NOTE: if we chose a region with no wines for the vintage/appellation/rank
    //       we ignore filteredAdditionalRivals and the account rivals instead
    if (filteredAdditionalRivals && filteredAdditionalRivals.length > 0) {
      dataCompareTab = dataCompareTab.concat(filteredAdditionalRivals);
    } else {
      dataCompareTab = dataCompareTab.concat(filteredRivals);
    }

    return (
      <Notes>
        <Wrapper>
          <FilterBloc
            marginBottom="20px"
            options={options || {}}
            {...this.state}
            disableRadio={this.numberOfTypes() !== 2}
            onChange={(field, value) => this.setState({ [field]: value })}
            handleChangeCall={(field, value) =>
              this.handleChangeCall(field, value)
            }
            onChangeRadio={(value) => this.handleRadioChange(value)}
          />
          <CompareTab
            exportName={this.getExportName()}
            loading={this.state.loading}
            data={dataCompareTab}
            isPrimeur={display[0].checked}
            type={display[0].checked ? 'Primeur' : 'Livrable'}
            wine={wine ? wine.label : ''}
            vintage={vintage ? vintage.label : ''}
            rank={rank}
            appelation={appellation}
          />
          <div className="compareTabContainer">
            <CompareBarGraph
              exportName={this.getExportName()}
              showLabel
              data={filteredData}
              rivals={filteredRivals ? filteredRivals : []}
              isPrimeur={display[0].checked}
              loading={this.state.loading}
            />
          </div>
          {display[0].checked ? (
            <div className="twoColumns">
              <CompareHistoryLineChart
                exportName={this.getExportName()}
                data={primeurGraphData}
                loading={this.state.loading}
                rivals={wine && rivals[wine.value] ? rivals[wine.value] : []}
                title={I18n.t('notes.compare.lineChartPrimeurTitle')}
                isPrimeur={true}
                taster={this.state.tasterPrimeur}
                onChangeTaster={(value) =>
                  this.setState({ tasterPrimeur: value })
                }
              />
              <WxrKpi
                title={`${I18n.t('notes.compare.indicatorPrimeurTitle')} - ${
                  this.state.tasterPrimeur ? this.state.tasterPrimeur.label : ''
                }`}
                indicators={kpiPrimeurChart}
                loading={this.state.loading}
                styles={`background-color: #ffff`}
              />
            </div>
          ) : (
            <div className="twoColumns">
              <CompareHistoryLineChart
                exportName={this.getExportName()}
                data={filteredData}
                dataWxr={filteredWxrHistory}
                rivals={filteredRivals}
                rivalsWxr={filteredWxrHistoryRivals}
                isPrimeur={false}
                loading={this.state.loading}
                title={`${I18n.t('notes.compare.lineChartVintageTitle')} ${
                  this.state.vintage ? this.state.vintage.value : ''
                }`}
                taster={this.state.tasterNote}
                onChangeTaster={(value) => this.setState({ tasterNote: value })}
              />
              <WxrKpi
                title={`${I18n.t('notes.compare.indicatorVintageTitle')} -  ${
                  this.state.vintage ? this.state.vintage.value : ''
                }`}
                indicators={kpiLastNote}
                loading={this.state.loading}
                styles={`background-color: #ffff`}
              />
            </div>
          )}
        </Wrapper>
      </Notes>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.notes.compare,
  headerCompare: state.notes.headerCompare,
  additionalRivals: state.notes.additionalRivals
});

const mapDispatchToProps = (dispatch) => ({
  getNotationCompare: async () => {
    await dispatch(getNotationCompare());
  },
  getNotationCompareAdditionalRivals: async (options) => {
    await dispatch(getNotationCompareAdditionalRivals(options));
  },
  getNotationHeaderCompare: async () => {
    await dispatch(getNotationHeaderCompare());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(NotesComparison);
